import { APP_CONFIG } from '../../env-cmdrc'

const wsUrl =
  APP_CONFIG.LOCAL_FRONT_LOCAL_BACKEND && APP_CONFIG.SAM_BACKEND_URL
    ? `${(APP_CONFIG.SAM_BACKEND_URL as string).replace(/^http/, 'ws')}/`
    : `${(APP_CONFIG.APP_BASE_URL as string).replace(/^http/, 'ws')}api/`

const config = {
  url: wsUrl,
}
export default config
